<template>
  <div v-if="checkout">
    <h1 class="program__top-title" v-html="design.title"></h1>
    <div class="program__top-text" v-html="design.intro"></div>
    <div class="program__top-price">${{program.price.toFixed(2)}} <span style="font-size: 0.9em;">{{ program.payment_type_text }}</span></div>

    <form class="program__signup-form" @submit.prevent="signupForm__submit" >

      <div class="program__error-message" v-if="error_message.length > 0">{{ error_message }}</div>

      <fieldset class="program__fieldset">
        <input class="program__text-field" type="text" name="first_name" v-model="checkout.first_name" placeholder="First Name">
        <input class="program__text-field" type="text" name="last_name" v-model="checkout.last_name" placeholder="Last Name">
      </fieldset>

      <fieldset class="program__fieldset">
        <input class="program__text-field" type="email" name="email" v-model="checkout.email" placeholder="email">
      </fieldset>

      <button class="button button--fill button--square program__signup-button">Sign Up</button>
    </form>
  </div>

</template>

<script>

import Checkout from "../../models/Checkout";
import router from "../../router/router";

export default {
  data(){
    return{
      error_message: "",
      checkout: null,
    }
  },
  computed: {
    program(){
      return this.$parent.program;
    },
    design(){
      return this.$parent.design;
    },
  },
  mounted(){

    console.log("this.program", this.program)
    this.checkout = Checkout.newInstance(this.program.document_id);
  },
  methods:{
    checkout_path(){
      return `/program/${this.program.document_id}/checkout/${this.checkout.document_id}`;
    },
    async signupForm__submit(){
      if(this.validateSubmission()){
        window.localStorage.setItem('emailForSignIn', this.checkout.email);
        await this.checkout.create();
        router.push(this.checkout_path())
      }
    },
    validateSubmission(){
      this.error_message = "";
      if(this.checkout.first_name.length < 2){
        this.error_message = "Please enter a first name";
        return false;
      }
      if(this.checkout.last_name.length < 2){
        this.error_message = "Please enter a last name";
        return false;
      }
      if(this.checkout.email.length < 4){
        this.error_message = "Please enter a valid email";
        return false;
      }
      return true;
    }
  }
}
</script>